<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{ $t(pageTitle) }}</h3>
      </div>
      <!-- <form class="form-horizontal"> -->
      <div class="box-body">
        <b-form class="form-horizontal">
          <div class="col-sm-12 col-md-6 col-lg-6">
            <div v-if="parseInt($route.params.id) !== 0" class="form-group">
              <label for="name" class="col-sm-3 control-label">{{
                $t("propertyMaintenance.assetCode")
              }}</label>
              <div class="col-sm-9">
                <b-form-input
                  v-model="assetData.code"
                  type="text"
                  required
                  class="form-control"
                  id="name"
                  :placeholder="$t('propertyMaintenance.assetCode')"
                  disabled
                />
              </div>
            </div>

            <div class="form-group">
              <label for="name" class="col-sm-3 control-label required">{{
                $t("property.asset.name")
              }}</label>
              <div class="col-sm-9">
                <b-form-input
                  v-model="assetData.name"
                  type="text"
                  required
                  class="form-control"
                  id="name"
                  :placeholder="$t('property.asset.name')"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="location" class="col-sm-3 control-label">{{
                $t("property.asset.location")
              }}</label>
              <div class="col-sm-9">
                <b-form-input
                  v-model="assetData.location"
                  type="text"
                  required
                  class="form-control"
                  id="location"
                  :placeholder="$t('property.asset.location')"
                />
              </div>
            </div>

            <lte-selectoptioncustom-type
              :item="itemAssetType"
              @onchangeselect="onChangeSelect"
            ></lte-selectoptioncustom-type>

            <div v-if="parseInt($route.params.id) !== 0" class="form-group">
              <label for="name" class="col-sm-3 control-label">{{
                $t("property.asset.assetCodeImport")
              }}</label>
              <div class="col-sm-9">
                <b-form-input
                  v-model="assetData.assetCodeImport"
                  type="text"
                  required
                  class="form-control"
                  id="name"
                  :placeholder="$t('property.asset.assetCodeImport')"
                  disabled
                />
              </div>
            </div>

            <div class="form-group">
              <label for="location" class="col-sm-3 control-label">{{
                $t("property.quantity")
              }}</label>
              <div class="col-sm-9">
                <b-form-input
                  v-model="assetData.quantity"
                  type="number"
                  required
                  class="form-control"
                  id="location"
                  :placeholder="$t('property.quantity')"
                  :disabled="
                    parseInt($route.params.id) !== 0 &&
                      !isAdmin() &&
                      !isSuperAdmin()
                  "
                />
              </div>
            </div>
            <div class="form-group">
              <label for="location" class="col-sm-3 control-label">{{
                $t("property.asset.price")
              }}</label>
              <div class="col-sm-9">
                <b-form-input
                  v-model="assetData.price"
                  type="number"
                  required
                  class="form-control"
                  id="location"
                  :placeholder="$t('property.asset.price')"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="" class="col-sm-3 control-label">{{
                $t("property.asset.assetUsers")
              }}</label>
              <div class="col-sm-9">
                <lte-selectoptiontable
                  :item="itemAssetUserList"
                  :placeHolder="$t('property.asset.assetUsers')"
                  :dropdown_titleLte="$t('property.asset.selectAssetUsers')"
                  ref="selectAddNewGroup"
                  @onchangeselect="onchangeselect"
                  :searchItem="getAssetUsers"
                ></lte-selectoptiontable>
              </div>
            </div>
            <hr />
            <div class="form-group">
              <label for="location" class="col-sm-3 control-label">{{
                $t("property.asset.origin")
              }}</label>
              <div class="col-sm-9">
                <b-form-input
                  v-model="assetData.origin"
                  type="text"
                  required
                  class="form-control"
                  id="location"
                  :placeholder="$t('property.asset.origin')"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="location" class="col-sm-3 control-label">{{
                $t("property.asset.manufacturingDate")
              }}</label>
              <div class="col-sm-9">
                <b-form-input
                  v-model="assetData.manufacturingDate"
                  type="text"
                  required
                  class="form-control"
                  id="location"
                  :placeholder="$t('property.asset.manufacturingDate')"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="" class="col-sm-3 control-label">{{
                $t("property.asset.provider")
              }}</label>
              <div class="col-sm-9">
                <!-- <div class="input-group">
                  <b-form-input
                    v-model="assetData.provider"
                    type="text"
                    required
                    class="form-control"
                    id="location"
                    :placeholder="$t('property.asset.provider')"
                  />
                  <span class="input-group-addon btn">
                    <i class="fa fa-search"></i>
                  </span>
                </div> -->
                <div class="input-group">
                  <v-select
                    class="clear"
                    :options="supplierList"
                    :getOptionLabel="option => option.name"
                    :reduce="data => data.id"
                    label="text"
                    :placeholder="$t('property.asset.provider')"
                    v-model="assetData.provider"
                  >
                    <template v-slot:option="option">
                      {{ $t(option.name) }}
                    </template>
                  </v-select>
                  <span
                    @click="addNewSupplier($event)"
                    :title="$t('supplierManagement.addNew')"
                    class="input-group-addon btn"
                  >
                    <i class="fa fa-plus"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="location" class="col-sm-3 control-label">{{
                $t("property.asset.assetContactPerson")
              }}</label>
              <div class="col-sm-9">
                <b-form-input
                  v-model="assetData.assetContactPerson"
                  type="text"
                  required
                  class="form-control"
                  id="location"
                  :placeholder="$t('property.asset.assetContactPerson')"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="location" class="col-sm-3 control-label">{{
                $t("property.asset.model")
              }}</label>
              <div class="col-sm-9">
                <b-form-input
                  v-model="assetData.assetModel"
                  type="text"
                  required
                  class="form-control"
                  id="location"
                  :placeholder="$t('property.asset.model')"
                />
              </div>
            </div>

            <div class="form-group">
              <label for="location" class="col-sm-3 control-label">{{
                $t("property.asset.seriCode")
              }}</label>
              <div class="col-sm-9">
                <b-form-input
                  v-model="assetData.seriCode"
                  type="text"
                  required
                  class="form-control"
                  id="location"
                  :placeholder="$t('property.asset.seriCode')"
                />
              </div>
            </div>
            <div class="form-group">
              <label for="" class="col-sm-3 control-label">{{
                $t("property.asset.guaranteePeriod")
              }}</label>
              <div class="col-sm-9">
                <date-picker
                  :config="options"
                  :placeholder="$t('property.asset.guaranteePeriod')"
                  v-model="assetData.guaranteePeriod"
                ></date-picker>
              </div>
            </div>
            <div class="form-group">
              <label for="" class="col-sm-3 control-label">{{
                $t("property.asset.propertyReceiptDate")
              }}</label>
              <div class="col-sm-9">
                <date-picker
                  :config="options"
                  :placeholder="$t('property.asset.propertyReceiptDate')"
                  v-model="assetData.propertyReceiptDate"
                ></date-picker>
              </div>
            </div>
            <div class="form-group">
              <label for="" class="col-sm-3 control-label">{{
                $t("property.asset.assetContactPhone")
              }}</label>
              <div class="col-sm-9">
                <b-form-input
                  v-model="assetData.assetContactPhone"
                  type="text"
                  required
                  class="form-control"
                  id="location"
                  :placeholder="$t('property.asset.assetContactPhone')"
                />
              </div>
            </div>
            <hr />

            <div class="form-group">
              <label for="" class="col-sm-3 control-label">{{
                $t("property.asset.maintainance_repeat_option")
              }}</label>
              <div class="col-sm-9">
                <div class="row">
                  <div class="radio">
                    <div class="col-sm-6">
                      <label>
                        <input
                          type="radio"
                          name="optionsRadios"
                          id="optionsRadios1"
                          :value="1"
                          v-model="assetData.maintainanceType"
                          checked
                        />
                        {{ $t("property.asset.maintenanceOnce") }}
                      </label>
                    </div>
                    <div class="col-sm-6">
                      <label>
                        <input
                          type="radio"
                          name="optionsRadios"
                          id="optionsRadios1"
                          v-model="assetData.maintainanceType"
                          :value="2"
                          checked
                        />
                        {{ $t("property.asset.cyclical") }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-show="assetData.maintainanceType === 2" class="form-group">
              <label for="" class="col-sm-3 control-label">{{
                $t("property.asset.maintenanceCycleList.cyclicalTitle")
              }}</label>
              <div class="col-sm-9">
                <v-select
                  class="clear"
                  :options="maintenanceCycleList"
                  :getOptionLabel="option => $t(option.text)"
                  :reduce="data => data.value"
                  label="text"
                  :placeholder="
                    $t('property.asset.maintenanceCycleList.cyclicalTitle')
                  "
                  v-model="assetData.maintenanceCycle"
                >
                  <template v-slot:option="option">
                    {{ $t(option.text) }}
                  </template>
                </v-select>
              </div>
            </div>

            <div class="form-group">
              <label for="" class="col-sm-3 control-label">{{
                $t("property.asset.lastMaintenanceDate")
              }}</label>
              <div class="col-sm-9">
                <date-picker
                  :config="options"
                  :placeholder="$t('property.asset.lastMaintenanceDate')"
                  v-model="assetData.lastMaintenanceDate"
                ></date-picker>
              </div>
            </div>

            <div class="form-group">
              <label for="" class="col-sm-3 control-label">{{
                $t("property.asset.nextMaintainanceDate")
              }}</label>
              <div class="col-sm-9">
                <date-picker
                  :config="options"
                  :placeholder="$t('property.asset.nextMaintainanceDate')"
                  v-model="assetData.nextMaintainanceDate"
                ></date-picker>
              </div>
            </div>

            <hr />

            <div class="form-group">
              <label for="" class="col-sm-3 control-label">{{
                $t("property.asset.unitsUsed")
              }}</label>
              <div class="col-sm-9">
                <v-select
                  class="clear"
                  :options="departmentList"
                  :reduce="data => data.id"
                  :getOptionLabel="option => $t(option.name)"
                  v-model="assetData.unitsUsed"
                  :placeholder="$t('property.asset.unitsUsed')"
                >
                  <template v-slot:option="option">
                    {{ option.name }}
                  </template>
                </v-select>
              </div>
            </div>

            <div class="form-group">
              <label for="asset_status" class="col-sm-3 control-label">{{
                $t("property.asset.status")
              }}</label>
              <div class="col-sm-9">
                <b-form-select
                  :options="assetStatus"
                  v-model="assetData.asset_status"
                  class="form-control"
                />
              </div>
            </div>

            <div
              v-if="assetData.asset_status === assetStatusEnum.LIQUIDATED"
              class="form-group"
            >
              <label for="" class="col-sm-3 control-label">{{
                $t("property.asset.liquidationDate")
              }}</label>
              <div class="col-sm-9">
                <date-picker
                  :config="options"
                  :placeholder="$t('property.asset.liquidationDate')"
                  v-model="assetData.liquidationDate"
                ></date-picker>
              </div>
            </div>

            <div class="form-group">
              <label for="" class="col-sm-3 control-label">{{
                $t("property.asset.description")
              }}</label>
              <div class="col-sm-9">
                <textarea
                  class="form-control"
                  name=""
                  id=""
                  cols="30"
                  rows="6"
                  :placeholder="$t('property.asset.description')"
                  v-model="assetData.description"
                ></textarea>
              </div>
            </div>

            <!-- <hr /> -->
          </div>
          <div class="col-sm-12 col-md-6 col-lg-6">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group required" style="text-align: center">
                  <label class="control-label label-text-center">{{
                    $t("banner.image")
                  }}</label>
                  <div class="">
                    <img
                      id="asset-img-id"
                      class="asset-img-class img-responsive"
                      :src="
                        assetData.imgUrl !== null && assetData.imgUrl !== ''
                          ? assetData.imgUrl
                          : noImgDefault
                      "
                      alt="asset-img"
                    />
                    <div style="padding-top: 6px;">
                      <input
                        id="upload-asset-img"
                        type="file"
                        accept="image/*"
                        @change="onSelectAssetImg"
                      />
                      <p>
                        <small>{{
                          $t("banner.clickImageToAddOrUpdate")
                        }}</small>
                      </p>
                      <span
                        v-if="
                          assetData.imgUrl !== null && assetData.imgUrl !== ''
                        "
                        class="remove-asset-img"
                        @click="onClickRemoveAssetImg"
                        >{{ $t("common.delete") }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6" v-if="parseInt(assetData.id) !== 0">
                <div class="form-group" style="text-align: center">
                  <label for="name" class="control-label label-text-center">{{
                    $t("property.qrcode")
                  }}</label>
                  <div
                    v-if="assetData.code !== null || assetData.code !== ''"
                    style="width: fit-content;
                    margin: auto;
                    padding: 6px;
                    border: 1px solid;"
                  >
                    <qr-code
                      :text="assetData.code"
                      :size="150"
                      color="#000000"
                      bg-color="#fff"
                      error-level="H"
                      style="
                        margin: auto;
                        align-items: center;
                        justify-content: center;
                        display: flex;
                      "
                    ></qr-code>
                  </div>
                  <div
                    v-if="assetData.code !== null || assetData.code !== ''"
                    style="padding: 5px"
                  >
                    <span
                      style="padding: 3px 5px;
                        border-radius: 15px;
                        background: #DDDDDD;
                        font-weight: bold;"
                      >{{ assetData.code }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-form>
        <!-- end contact -->
        <!-- Temporary Close -->
      </div>
      <div class="box-footer">
        <button
          type="button"
          class="btn btn-labeled btn-danger"
          style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
          @click="cancelAsset"
        >
          <span class="btn-label"> <i class="fa fa-mail-reply"></i> </span>
          {{ $t("common.back") }}
        </button>
        <!-- @click="saveAssetList" -->
        <button
          type="button"
          class="btn btn-labeled btn-success pull-right"
          @click="saveAssetList"
          style="margin-right: 5px;"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-ok"></i>
          </span>
          {{ $t("common.save") }}
        </button>
      </div>
      <!-- </form> -->
    </div>
    <detail-asset-history
      v-show="parseInt($route.params.id) !== 0"
      :assetId="assetData.id"
    />
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <router-view></router-view>
    <!--  -->
    <supplier-detail-modal
      ref="supplierDetailModal"
      @callbackSupplierList="callbackSupplierList"
    />
  </div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import SelectOptionCustom from "@/components/SelectOptionCustom.vue";
import SelectOptionSearchUser from "@/components/SelectOptionSearchUser.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import constants from "@/lib/constantsData";
import { mapGetters, mapActions } from "vuex";
import config from "../../../build/config";
import utils, { uploadFileToMediaAgent } from "@/lib/utils";
import configuration from "@/lib/config";
import DetailAssetHistory from "./DetailAssetHistory";
import SupplierDetailModal from "./SupplierDetailModal";
import Enum from "../../../enum/enum";

export default {
  name: "AssetAdd",
  data() {
    return {
      is_edit_form: false,
      actionType: "",
      contacterlist: [],
      itemAssetType: {
        func_get_list: this.GET_ASSET_TYPE_LIST,
        func_add: this.ADD_ASSET_TYPE,
        itemType: null,
        showLabel: true,
        modifyFromPosition: "margin-left:15px",
        cssClassSm1: "col-sm-3",
        cssClassSm2: "col-sm-9",
        showAddNew: false
      },
      itemAssetSubType: {
        func_get_list: this.GET_ASSET_SUB_TYPE_LIST,
        func_add: this.ADD_ASSET_SUB_TYPE,
        itemType: 1,
        showLabel: true,
        required: true,
        titleLabel: this.$t("case.subtype"),
        modifyFromPosition: "margin-left:15px",
        cssClassSm1: "col-sm-3",
        cssClassSm2: "col-sm-9",
        onItemChange: false,
        editItemChange: undefined
      },
      maintainanceSubType: constants.maintainanceSubType,
      maintainanceSubType1: constants.maintainanceSubType1,
      maintainanceSubType2: constants.maintainanceSubType2,
      assetStatus: [],
      show: false,
      noqrcode: "noqrcode.png",
      options: {
        format: "DD-MM-YYYY",
        useCurrent: false
      },
      assetData: {
        id: 0,
        name: null,
        location: null,
        asset_status: 1,
        nextMaintainanceDate: null,
        code: "",
        imgUrl: "",
        type: null,
        unitsUsed: null,
        maintainanceType: 1,
        lastMaintenanceDate: null,
        maintenanceCycle: null,
        description: null,
        quantity: 1,
        price: null,
        assetUsers: null,
        assetCodeImport: null,
        provider: null,
        assetContactPerson: null,
        propertyReceiptDate: null,
        origin: null,
        manufacturingDate: null,
        assetModel: null,
        seriCode: null,
        guaranteePeriod: null,
        assetContactPhone: null,
        liquidationDate: null
      },
      assetImgFileSize: null,
      assetImgFile: null,
      apartmentAssetList: [],
      apartmentAsset: 0,
      disabledApartmentAsset: false,
      pageTitle: "property.asset.new_asset_page",
      isEdit: false,
      noImgDefault: configuration.imgUrlConfig.img_other_no_picture_available,
      departmentList: [],
      maintenanceCycleList: constants.maintenanceCycleList,
      itemAssetUserList: {
        data_list: [],
        itemType: 0,
        showLabel: false,
        modifyFromPosition: "margin-top:-300px",
        cssClassSm1: "col-md-12",
        cssClassSm2: "col-sm-12",
        showAddNew: false
      },
      getAssetUsers: {},
      supplierList: [],
      assetStatusEnum: Enum.AssetStatusEnum
    };
  },

  watch: {
    GET_USER_DATA: function() {
      this.contacterlist = [];
      this.GET_USER_DATA.forEach(user => {
        let full_name = `${user.firstname} ${user.lastname}`;
        let item = {
          value: user.id,
          text: full_name
        };
        this.contacterlist.push(item);
      });
    },
    // watch asset detail
    ASSET_DETAIL_DATA: function() {
      let data = this.ASSET_DETAIL_DATA;
      this.assetData.id = data.id;
      this.assetData.name = data.name;
      this.assetData.location = data.location;
      this.assetData.type = data.asset_type;
      // get value SelectOptionCustom
      this.itemAssetType.itemType = data.asset_type;
      this.assetData.lastMaintenanceDate = utils.formatSqlDate(data.last_maintenance_date, null, "DD-MM-YYYY");
      this.assetData.asset_status = data.asset_status;
      // this.assetData.maintenancePersonnel = data.contacter;
      this.assetData.nextMaintainanceDate = utils.formatSqlDate(data.next_maintainance_date, null, "DD-MM-YYYY");
      this.assetData.code = data.code;
      this.assetData.imgUrl = data.img_url;
      this.assetData.description = data.description;
      this.assetData.maintainanceType = data.maintenance_type;
      this.assetData.maintenanceCycle = data.maintenance_cycle;
      this.assetData.unitsUsed = data.department;
      this.assetData.quantity = data.quantity;
      this.assetData.assetUsers = data.asset_user;
      this.getAssetUsers = {
        id: data.asset_user_data != null ? data.asset_user_data.id : null,
        full_name:
          data.asset_user_data != null ? data.asset_user_data.full_name : "---",
        email: data.asset_user_data != null ? data.asset_user_data.email : null
      };
      this.assetData.assetCodeImport = data.asset_code_import;
      this.assetData.provider = data.asset_supplier;
      this.assetData.assetContactPerson = data.asset_contact_person;
      this.assetData.propertyReceiptDate = utils.formatSqlDate(data.asset_receipt_date, null, "DD-MM-YYYY");
      this.assetData.origin = data.origin;
      this.assetData.manufacturingDate = utils.getCleanStringValue(data.manufacturing_date);
      this.assetData.seriCode = data.seri_code;
      this.assetData.guaranteePeriod = utils.formatSqlDate(data.guarantee_period, null, "DD-MM-YYYY");
      this.assetData.assetContactPhone = data.asset_contact_phone;
      this.assetData.liquidationDate = utils.formatSqlDate(data.liquidation_date, null, "DD-MM-YYYY");
      this.assetData.price = data.price
      this.assetData.assetModel = data.asset_model
    },
    GET_DEPARTMENT_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_DEPARTMENT_LIST_NO_PAGE_DATA;
      this.departmentList = [];
      data.forEach(value => {
        let item = {
          id: value.id,
          name: value.name
        };
        this.departmentList.push(item);
      });
    },
    GET_ASSET_SUPPLIER_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_ASSET_SUPPLIER_LIST_NO_PAGE_DATA;
      this.supplierList = [];
      data.forEach(e => {
        let item = {
          id: e.id,
          name: e.name
        };
        this.supplierList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "ASSET_DETAIL_DATA",
      "GET_DEPARTMENT_LIST_NO_PAGE_DATA",
      "GET_USER_DATA",
      "GET_MAINTENANCE_TYPE_LIST_DATA",
      "GET_ACCOUNT_DATA",
      "GET_ASSET_SUPPLIER_LIST_NO_PAGE_DATA"
    ]),
    imageSrc: function() {
      let qrcode = this.noqrcode;
      var url = "/media/QRCode/";

      if (this.assetData.id != 0) {
        qrcode = this.assetData.id + ".png";
        url += "asset/";
      }
      let backendURL = config.BACKEND_URL;
      return backendURL + url + qrcode;
    }
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "ADD_ASSET_V2",
      "GET_ASSET_DETAIL",
      "UPDATE_ASSET_V2",
      "GET_ASSET_TYPE_LIST",
      "ADD_ASSET_TYPE",
      "GET_ASSET_STATUS_LIST",
      "GET_ASSET_SUB_TYPE_LIST",
      "ADD_ASSET_SUB_TYPE",
      "GET_APARTMENT_LIST",
      "GET_USER_LIST",
      "GET_DEPARTMENT_LIST",
      "GET_ASSET_SUPPLIER_LIST"
    ]),
    isAdmin: function() {
      return utils.isAdmin(this.GET_ACCOUNT_DATA);
    },
    isSuperAdmin: function() {
      return utils.isSuperAdmin(this.GET_ACCOUNT_DATA);
    },
    fuseSearch(options, search) {
      let resultSearch = options.filter(x =>
        utils
          .replaceCharactersVNLanguage(x.text.toLowerCase())
          .includes(utils.replaceCharactersVNLanguage(search.toLowerCase()))
      );
      return search.length > 0 && resultSearch.length > 0 ? resultSearch : [];
    },
    validatAssetData: function() {
      let validateResult = "OK";
      for (let key in this.assetData) {
        if (
          key === "imgUrl" ||
          key === "code" ||
          key === "nextMaintainanceDate" ||
          key === "maintainance_start_date" ||
          key === "asset_status" ||
          key === "unitsUsed" ||
          key === "maintenanceCycle" ||
          key === "description" ||
          key === "lastMaintenanceDate" ||
          key === "nextMaintainanceDate" ||
          key === "assetUsers" ||
          key === "assetCodeImport" ||
          key === "location" ||
          key === "provider" ||
          key === "assetContactPerson" ||
          key === "propertyReceiptDate" ||
          key === "origin" ||
          key === "manufacturingDate" ||
          key === "assetModel" ||
          key === "seriCode" ||
          key === "guaranteePeriod" ||
          key === "assetContactPhone" ||
          key === "liquidationDate" ||
          key === "price" ||
          key === "quantity"
        ) {
          //
        } else if (
          !utils.isEmptyString(this.assetData.assetContactPhone) &&
          !utils.validatePhone(this.assetData.assetContactPhone.replace(/ /g, ""))
        ) {
          validateResult = this.$t("user.inform_modal[0].phone_number_error");
          break;
        } else if (utils.isEmptyString(this.assetData[key])) {
          validateResult = this.$t("property.asset." + key);
          break;
        }
      }

      return validateResult;
    },
    saveAssetList: async function(event) {
      event.preventDefault();
      let results = this.validatAssetData();
      if (this.assetData.maintainanceType === 2 && utils.isEmptyString(this.assetData.maintenanceCycle)) {
        this.showError(
          this.$t("property.asset.maintenanceCycleList.cyclicalTitle")
        );
      } else if (results === "OK") {
        if (!utils.isEmptyString(this.assetImgFileSize)) {
          await this.uploadAssetImg();
        }
        let data = {
          id: this.assetData.id,
          name: this.assetData.name,
          location: this.assetData.location,
          type: this.assetData.type,
          maintenance_type: this.assetData.maintainanceType,
          last_maintenance_date: utils.formatSqlUtcDate(this.assetData.lastMaintenanceDate, "DD-MM-YYYY", "YYYY-MM-DD HH:mm:ss"),
          maintenance_cycle: this.assetData.maintenanceCycle,
          next_maintainance_date: utils.formatSqlUtcDate(this.assetData.nextMaintainanceDate, "DD-MM-YYYY", "YYYY-MM-DD HH:mm:ss"),
          department: this.assetData.unitsUsed,
          asset_status: this.assetData.asset_status,
          description: this.assetData.description,
          img_url: this.assetData.imgUrl,
          quantity: utils.getCleanStringValue(this.assetData.quantity),
          code: utils.getCleanStringValue(this.assetData.code),
          assetUsers: this.assetData.assetUsers,
          supplierId: this.assetData.provider,
          assetContactPerson: this.assetData.assetContactPerson,
          propertyReceiptDate: utils.formatSqlUtcDate(this.assetData.propertyReceiptDate, "DD-MM-YYYY", "YYYY-MM-DD HH:mm:ss"),
          origin: this.assetData.origin,
          manufacturingDate: utils.getCleanStringValue(this.assetData.manufacturingDate),
          assetModel: this.assetData.assetModel,
          seriCode: this.assetData.seriCode,
          guaranteePeriod: utils.formatSqlUtcEndOfDate(this.assetData.guaranteePeriod, "DD-MM-YYYY", "YYYY-MM-DD HH:mm:ss"),
          assetContactPhone: this.assetData.assetContactPhone,
          price: utils.getCleanStringValue(this.assetData.price),
          liquidationDate: utils.formatSqlUtcDate(this.assetData.liquidationDate, "DD-MM-YYYY", "YYYY-MM-DD HH:mm:ss")
        };
        if (parseInt(this.assetData.id) == 0) {
          this.ADD_ASSET_V2(data)
            .then(
              function() {
                this.callBack();

                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function() {
                this.ERROR_TOAST();
              }.bind(this)
            );
        } else {
          this.UPDATE_ASSET_V2(data)
            .then(
              function() {
                this.callBack();
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function() {
                this.ERROR_TOAST();
              }.bind(this)
            );
        }
      } else {
        this.showError(results);
      }
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    cancelAsset: function() {
      this.callBack();
    },
    onMaintainceType: function(val) {
      if (val == 1) {
        this.maintainanceSubType = this.maintainanceSubType1;
        this.assetData.maintainance_sub_type = this.maintainanceSubType[1].value;
      } else {
        this.maintainanceSubType = this.maintainanceSubType2;
        this.assetData.maintainance_sub_type = this.maintainanceSubType[1].value;
      }
    },

    onChangeInstallDate: function(e) {
      this.assetData.installed_date = e.date.format("YYYY-MM-DDThh:mm");
    },

    onSave() {
      this.$refs.formsubmitbutton.click();
    },
    onChangeSelect: function(type_value) {
      this.assetData.type = type_value;
      this.itemAssetSubType.itemType = type_value;
      this.itemAssetSubType.onItemChange = true;
      //this.assetData.asset_sub_type = type_value;
    },
    callBack() {
      this.$router.push({
        name: "AssetList"
      });
    },
    /**
     * Select issuance img
     */
    onSelectAssetImg: function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.getResultFile(files[0]);
      this.assetImgFileSize = files[0].size;
      this.assetData.imgUrl = URL.createObjectURL(files[0]);
    },
    /**
     * Remove issuance img
     */
    onClickRemoveAssetImg: function() {
      let inputForm = $("#upload-asset-img");
      inputForm.val("");
      this.assetImgFile = null;
      this.assetImgFileSize = null;
      this.assetData.imgUrl = null;
    },
    /**
     * Get result file
     */
    getResultFile: function(file) {
      let vm = this;
      vm.assetImgFile = file;
    },
    uploadAssetImg: async function() {
      if (this.assetImgFileSize > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("common.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        this.assetData.imgUrl = await uploadFileToMediaAgent(this.assetImgFile, "assetImg")
      }
    },
    getDepartmentList: function() {
      this.GET_DEPARTMENT_LIST();
    },
    onchangeselect: function(data) {
      this.assetData.assetUsers = data;
    },
    getAssetSupplierList: function() {
      let filter = {
        params: {
        }
      };
      this.isLoading = true;
      this.GET_ASSET_SUPPLIER_LIST(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    addNewSupplier: function(event) {
      event.preventDefault();
      this.$refs.supplierDetailModal.onAddNewSupplier();
    },
    callbackSupplierList: function() {
      this.getAssetSupplierList();
    }
  },
  mounted() {
    $(function() {
      $("#asset-img-id").on("click", function() {
        $("#upload-asset-img").click();
      });
    });
    this.GET_USER_LIST();
    let id = this.$route.params.id;
    this.GET_ASSET_STATUS_LIST().then(
      function(res) {
        let assetStatusList = res.data;
        let assetStatus = [];
        assetStatusList.forEach(data => {
          let item = {
            value: data.id,
            text: data.name
          };
          assetStatus.push(item);
        });
        this.assetStatus = assetStatus;
      }.bind(this)
    );
    this.getDepartmentList();
    this.getAssetSupplierList();
    //
    if (parseInt(id) !== 0) {
      this.is_edit_form = true;
      this.disabledApartmentAsset = true;
      this.assetData.id = id;
      this.GET_ASSET_DETAIL({ id: id }).then(
        function() {
          this.itemAssetSubType.onItemChange = true;
          this.isEdit = true;
        }.bind(this)
      );
      this.show = true;
      this.pageTitle = "property.asset.edit_asset_page";
    } else {
      this.itemAssetType.itemType = this.assetData.type;
      this.onMaintainceType(this.assetData.maintainance_repeat_option);
    }
    let apartment_id = this.$route.params.apartment_id;
    if (!utils.isNull(apartment_id) && parseInt(apartment_id) != 0) {
      let apartment_code = this.$route.params.apartment_code;
      this.apartmentAssetList.push({
        value: apartment_id,
        text: apartment_code
      });
      this.apartmentAsset = apartment_id;
    } else {
      this.apartmentAssetList.push({
        value: 0,
        text: this.$t("property.asset.commonproperty")
      });
      const filter = {
        params: {
          apt_type: 1,
          asset: "asset",
          isGetAllApartment: "True"
        }
      };
      this.GET_APARTMENT_LIST(filter)
        .then(
          function(res) {
            let data = res.data;
            for (let i = 0, size = data.length; i < size; i++) {
              this.apartmentAssetList.push({
                value: data[i].id,
                text: data[i].apartment_code
              });
            }
          }.bind(this)
        )
        .catch(function(error) {
          // To do
        });
    }
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    "date-picker": datePicker,
    "lte-selectoptioncustom-type": SelectOptionCustom,
    "lte-selectoptiontable": SelectOptionSearchUser,
    DetailAssetHistory,
    SupplierDetailModal
    // "lte-selectoptioncustom-subtype": SelectOptionCustom
  }
};
</script>

<style lang="scss" scoped>
label.required:not(:empty):after,
.field-header.required:after {
  content: " *";
  color: red;
  position: absolute;
  right: 5px;
  top: 0px;
}

input[type="file"] {
  display: none;
}

.remove-asset-img {
  color: #ef5350;
  cursor: pointer;
}

.label-text-center {
  padding-bottom: 10px;
}
.asset-img-class {
  margin: auto;
  width: 100%;
  max-width: 200px;
  max-height: 250px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/views/Property/AssetAddV2.vue